import { render, staticRenderFns } from "./SmallBox.vue?vue&type=template&id=a4c3ec7c&scoped=true"
import script from "./SmallBox.vue?vue&type=script&lang=js"
export * from "./SmallBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c3ec7c",
  null
  
)

export default component.exports